import useSubscriptionPlan from './useSubscriptionPlan';

export default function useIsFreeTierTenant(): boolean | undefined {
  const subscriptionPlan = useSubscriptionPlan();
  return subscriptionPlan?.is_free_tier;
}
